"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const food_1 = require("./food");
exports.food = food_1.food;
exports.FoodType = food_1.FoodType;
const transport_1 = require("./transport");
exports.transport = transport_1.transport;
exports.TransportType = transport_1.TransportType;
const electricity_1 = require("./electricity");
exports.electricity = electricity_1.electricity;
exports.ElectricityType = electricity_1.ElectricityType;
const internet_1 = require("./internet");
exports.getInternetUsageCarbonImpact = internet_1.getInternetUsageCarbonImpact;
const streaming_1 = require("./streaming");
exports.streaming = streaming_1.streaming;
exports.StreamingType = streaming_1.StreamingType;
const purchase_1 = require("./purchase");
exports.purchase = purchase_1.purchase;
exports.PurchaseType = purchase_1.PurchaseType;
const fashion_1 = require("./fashion");
exports.fashion = fashion_1.fashion;
exports.FashionType = fashion_1.FashionType;
const meal_1 = require("./meal");
exports.meal = meal_1.meal;
exports.MealType = meal_1.MealType;
